import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, switchMap, take } from "rxjs";
import { Store } from "@ngrx/store";

import { activeOrganization } from "@app/features/auth/store/auth.selectors";

@Injectable()
export class OrganizationInterceptor<T> implements HttpInterceptor {
  private readonly store = inject(Store);

  intercept(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return this.store.select(activeOrganization).pipe(
      take(1),
      switchMap((organization) => {
        if (organization && organization.id) {
          return next.handle(
            req.clone({
              setHeaders: {
                OrganizationId: organization.id
              }
            })
          );
        }

        return next.handle(req);
      })
    );
  }
}
